export const EN_CAMPAIGN_STRINGS = {
  CAMPAIGNS: '{count, plural, one {Campaign} other {Campaigns}}',
  CAMPAIGN_ENTITY_NAME: 'Campaign',
  CAMPAIGN_METADATA_LABEL: 'Metadata',
  CAMPAIGN_METADATA_INTERNAL_NAME_LABEL: 'Internal Name',
  CAMPAIGN_METADATA_INTERNAL_NAME_HINT:
    '<strong>Required.</strong> This internal-facing name is used to find this campaign in the system. It is not shown to end-users.',
  CAMPAIGN_METADATA_EXTERNAL_ID_LABEL: 'External ID',
  CAMPAIGN_METADATA_EXTERNAL_ID_HINT:
    'Use this field to add an external reference ID if this campaign needs to be mapped to another system.',
  CAMPAIGN_EXTERNAL_IDENTIFIERS_LABEL: 'External Identifiers',
  CAMPAIGN_EXTERNAL_IDENTIFIERS_HINT:
    'Use this to add one or more external reference IDs. For each entry, both Identifier Name and Identifier Value are required and cannot be blank.',
  CAMPAIGN_EXTERNAL_IDENTIFIER_LABEL: 'External Identifier',
  CAMPAIGN_EXTERNAL_IDENTIFIER_NAME_LABEL: 'Identifier Name',
  CAMPAIGN_EXTERNAL_IDENTIFIER_NAME_HINT:
    '<strong>Required.</strong> Enter the external name',
  CAMPAIGN_EXTERNAL_IDENTIFIER_VALUE_LABEL: 'Identifier Value',
  CAMPAIGN_EXTERNAL_IDENTIFIER_VALUE_HINT:
    '<strong>Required.</strong> Enter the value of the external name',
  CAMPAIGN_METADATA_TYPE_LABEL: 'Type',
  CAMPAIGN_METADATA_TYPE_HINT:
    "<strong>Required.</strong> Choose the program type: <br></br> 'Opt-in': Users can choose to enrol into the campaign <br></br> 'Suggested': Users are auto-enrolled and must complete the campaign in a certain time frame <br></br> 'Reward': Users are auto-enrolled with incentives <br></br> 'Challenge': Users can compete against themselves or a group of people",
  CAMPAIGN_DATE_LABEL: 'Campaign Duration',
  CAMPAIGN_DATE_HINT:
    'Optional. The dates this campaign is active and/or visible. Use YYYY-MM-DD format.',
  CAMPAIGN_DATE_START_DATE_LABEL: 'Start Date',
  CAMPAIGN_DATE_START_DATE_HINT:
    "The date the campaign begins. If you leave this blank, the campaign will be available as soon as it's published.",
  CAMPAIGN_DATE_END_DATE_LABEL: 'End Date',
  CAMPAIGN_DATE_END_DATE_HINT:
    'The date the campaign ends. If you leave this blank, the campaign will run forever until it is unpublished.',
  CAMPAIGN_DATE_VISIBILITY_END_DATE_HINT:
    'The date the campaign disappears from the app. This is useful if you want users to see their results for a while after the campaign has ended.',
  CAMPAIGN_DATE_VISIBILITY_END_DATE_LABEL: 'Visibility End Date',
  CAMPAIGN_CONTENT_LABEL: 'Content',
  CAMPAIGN_CONTENT_TITLE_LABEL: 'Title',
  CAMPAIGN_CONTENT_TITLE_HINT:
    "<strong>Required</strong> for all campaign types except 'suggested'. This is the main title the user will see in the app.",
  CAMPAIGN_CONTENT_PROGRAM_HEADER_LABEL: 'Program Header',
  CAMPAIGN_CONTENT_PROGRAM_HEADER_HINT:
    'Text entered here will appear as a small promotional "badge" on the campaign card (e.g. "New", "Featured", etc.)',
  CAMPAIGN_CONTENT_SHORT_DESCRIPTION_LABEL: 'Short Description',
  CAMPAIGN_CONTENT_SHORT_DESCRIPTION_HINT:
    'A short summary that appears on the campaign preview card. For best results, we recommend keeping this under 150 characters.',
  CAMPAIGN_CONTENT_LONG_DESCRIPTION_LABEL: 'Long Description',
  CAMPAIGN_CONTENT_LONG_DESCRIPTION_HINT:
    'A more detailed description of the campaign. For reliability, we recommend keeping this under 600 characters.',
  CAMPAIGN_CONTENT_OVERVIEW_LABEL: 'Overview',
  CAMPAIGN_CONTENT_OVERVIEW_HINT:
    'This is the main content area for the campaign details page. You can use rich text formatting like bolding and lists.',
  CAMPAIGN_CONTENT_CAMPAIGN_IMAGE_ID_LABEL: 'Campaign Image ID',
  CAMPAIGN_CONTENT_CAMPAIGN_IMAGE_ID_HINT:
    "An image is <strong>required</strong> for all campaign types except 'suggested'. This image is used on both the campaign card and details page.",
  CAMPAIGN_CONTENT_ACHIEVEMENT_LABEL: 'Achievement',
  CAMPAIGN_CONTENT_ACHIEVEMENT_ENABLED_LABEL:
    'Award User with an Achievement Badge',
  CAMPAIGN_CONTENT_ACHIEVEMENT_ENABLED_HINT:
    'Check this box if you want to award users a special achievement badge when they complete the campaign.',
  CAMPAIGN_CONTENT_ACHIEVEMENT_TITLE_LABEL: 'Title',
  CAMPAIGN_CONTENT_ACHIEVEMENT_TITLE_HINT:
    'Enter the program name (for Challenges) or other standard text (for Reward Programs).',
  CAMPAIGN_CONTENT_ACHIEVEMENT_TEXT_LABEL: 'Description/Short Text',
  CAMPAIGN_CONTENT_ACHIEVEMENT_TEXT_HINT:
    'Enter short standard text/message for Reward Programs; leave blank for other cases.',
  CAMPAIGN_CONTENT_ACHIEVEMENT_IMAGE_LABEL: 'Achievement Image',
  CAMPAIGN_CONTENT_ACHIEVEMENT_IMAGE_HINT:
    'The image or icon for the achievement badge.',
  CAMPAIGN_CONTENT_ACHIEVEMENT_THRESHOLD_LABEL: 'Threshold',
  CAMPAIGN_CONTENT_ACHIEVEMENT_THRESHOLD_HINT:
    'Specify how many activities a user must complete to receive this achievement reward.',
  CAMPAIGN_CONTENT_ACHIEVEMENT_GLOBAL_PROGRESS_LABEL: 'Display Global Progress',
  CAMPAIGN_CONTENT_ACHIEVEMENT_GLOBAL_PROGRESS_HINT:
    'Check this box if you want users to see a progress bar for this campaign on the campaign card.',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER: 'Disclaimer Banner',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_HINT:
    'Optional. Use these fields to show a prominent disclaimer banner on the campaign details page.',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_TITLE_LABEL: 'Title',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_TITLE_HINT:
    'The title of the disclaimer banner.',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_DESCRIPTION_LABEL: 'Description',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_DESCRIPTION_HINT:
    'The main text of the disclaimer banner.',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_DESCRIPTION_RICH_TEXT_LABEL:
    'Description (Rich Text)',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_DESCRIPTION_RICH_TEXT_HINT:
    'Rich text version of the disclaimer banner description. Use this when formatted content is needed.',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_ICON_IMAGE_ID_LABEL: 'Icon Image',
  CAMPAIGN_CONTENT_DISCLAIMER_BANNER_ICON_IMAGE_HINT:
    'An optional icon to display next to the disclaimer text.',
  CAMPAIGN_CONTENT_PROGRAM_RULES_LABEL: 'Program Rules Text',
  CAMPAIGN_CONTENT_PROGRAM_RULES_HINT:
    'Explains what the user needs to do to unlock program rewards (only for Reward Programs). Provide clear and concise instructions.',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_LABEL: 'Content Provider',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_HINT:
    'Optional. If this campaign content is from a partner or vendor, fill out their information here to display it in the app.',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_NAME_LABEL: 'Name',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_NAME_HINT:
    'The name of the content partner (e.g., "Healthwise").',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_DESCRIPTION_LABEL: 'Description',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_DESCRIPTION_HINT:
    'A short description of the content partner.',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_LOGOTYPE_IMAGE_ID_LABEL: 'Logotype Image',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_LOGOTYPE_IMAGE_HINT:
    "The partner's full text-style logo.",
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_LOGOMARK_IMAGE_ID_LABEL: 'Logomark Image',
  CAMPAIGN_CONTENT_CONTENT_PROVIDER_LOGOMARK_IMAGE_HINT:
    "The partner's icon-style logo.",
  CAMPAIGN_ENROLMENT_LABEL: 'Enrollment',
  CAMPAIGN_ENROLMENT_ELIGIBILITY_CRITERIA_LABEL: 'Eligibility Criteria',
  CAMPAIGN_ENROLMENT_ELIGIBILITY_CRITERIA_HINT:
    'If no rules are set, all users are eligible. This is a powerful but complex field; please consult documentation to configure correctly.',
  CAMPAIGN_ENROLMENT_ENROLMENT_METHOD_LABEL: 'Enrollment Method',
  CAMPAIGN_ENROLMENT_ENROLMENT_METHOD_HINT:
    "<strong>Required.</strong> 'Opt-in': Users choose to join. 'Auto-enrolled': Users are enrolled automatically. 'Assigned': A care team member assigns the campaign.",
  CAMPAIGN_ENROLMENT_ENROLMENT_DURATION_LABEL: 'Enrollment Duration',
  CAMPAIGN_ENROLMENT_ENROLMENT_DURATION_HINT:
    'Optional. The dates this campaign is accepting enrolment from users.',
  CAMPAIGN_ENROLMENT_ENROLMENT_DURATION_START_DATE_LABEL: 'Start Date',
  CAMPAIGN_ENROLMENT_ENROLMENT_DURATION_START_DATE_HINT:
    'The first day a user can enrol. If blank, users can enrol as soon as the campaign is active.',
  CAMPAIGN_ENROLMENT_ENROLMENT_DURATION_END_DATE_LABEL: 'End Date',
  CAMPAIGN_ENROLMENT_ENROLMENT_DURATION_END_DATE_HINT:
    'The last day a user can enrol. If blank, users can enrol at any time until the campaign itself ends.',
  CAMPAIGN_ENROLMENT_FRONT_LINE_CAMPAIGN_LABEL: 'Front of the Line Campaign',
  CAMPAIGN_ENROLMENT_FRONT_LINE_CAMPAIGN_HINT:
    'Check this box to make this campaign appear more prominently in user recommendations over other campaigns.',
  CAMPAIGN_ENROLMENT_ROOT_CAMPAIGN_LABEL: 'Is Root Campaign',
  CAMPAIGN_ENROLMENT_ROOT_CAMPAIGN_HINT:
    'This field is used by the system to manage nested campaigns. Check this box if this is the root campaign of a reward program, etc.',
  CAMPAIGN_ENROLMENT_CHILD_CAMPAIGNS_LABEL: 'Child Campaigns',
  CAMPAIGN_ENROLMENT_CHILD_CAMPAIGNS_HINT:
    'To nest other campaigns inside this one, add them here. Each added campaign is a <strong>required reference</strong> to a valid, existing campaign. Only used for Reward Programs that have nesting.',
  CAMPAIGN_ENROLMENT_CHILD_CAMPAIGNS_ADD_LABEL: 'Add Child Campaign',
  CAMPAIGN_COMPLETION_LABEL: 'Completion',
  CAMPAIGN_COMPLETION_COMPLETION_CRITERIA_LABEL: 'Completion Criteria',
  CAMPAIGN_COMPLETION_COMPLETION_CRITERIA_HINT:
    'If blank, users must complete all activities to finish the campaign. Use this for more complex completion rules (e.g., "complete campaign if user hits the max reward threshold").',
  CAMPAIGN_COMPLETION_MAX_REDEMPTION_POINTS_HINT:
    '<strong>Required.</strong> Must be a whole number, 0 or greater. This is the total point limit for the entire campaign. Leave as 0 if no points are awarded.',
  CAMPAIGN_COMPLETION_MAX_REDEMPTION_POINTS_LABEL: 'Max Redemption Points',
  CAMPAIGN_COMPLETION_REWARD_PROGRAM_GOAL_HINT:
    '<strong>Required.</strong> Must be a whole number, 0 or greater. This defines how many activities must be completed to get credit for a Rewards Program. Leave as 0 if not applicable.',
  CAMPAIGN_COMPLETION_REWARD_PROGRAM_GOAL_LABEL: 'Reward Program Goal',
  CAMPAIGN_COMPLETION_PROGRAM_COMPLETION_TITLE_LABEL:
    'Program Completion Title',
  CAMPAIGN_COMPLETION_PROGRAM_COMPLETION_TITLE_HINT:
    'A custom title shown to the user after they complete the campaign.',
  CAMPAIGN_COMPLETION_COMPLETION_MESSAGE_LABEL: 'Completion Message',
  CAMPAIGN_COMPLETION_COMPLETION_MESSAGE_HINT:
    'A custom message shown to the user after they complete the campaign. You can use rich text.',
  CAMPAIGN_COMPLETION_PROGRAM_ENDED_TITLE_LABEL: 'Program Ended Title',
  CAMPAIGN_COMPLETION_PROGRAM_ENDED_TITLE_HINT:
    "A custom title shown to the user after the campaign's end date has passed.",
  CAMPAIGN_COMPLETION_ENDED_MESSAGE_LABEL: 'Ended Message',
  CAMPAIGN_COMPLETION_ENDED_MESSAGE_HINT:
    "A custom message shown to the user after the campaign's end date has passed. You can use rich text.",
  CAMPAIGN_CAMPAIGN_NODES_ACTIVITIES_BANNER_TITLE:
    'The order of Activities matters.',
  CAMPAIGN_CAMPAIGN_NODES_ACTIVITIES_BANNER_DESCRIPTION:
    'The order is used for the priority by which the system chooses which activities to present to the user. The system chooses which activities to present to the user.',
  CAMPAIGN_CAMPAIGN_NODES_OFFSET_LABEL: 'Offset',
  CAMPAIGN_CAMPAIGN_NODES_OFFSET_HINT:
    'The number of days to wait before making these activities available to the user. Use 0 to make them available immediately.',
  CAMPAIGN_CAMPAIGN_NODES_ACTIVITIES_LABEL: 'Activities',
  CAMPAIGN_CAMPAIGN_NODES_ACTIVITIES_ACTIVITY_ID_LABEL: 'Activity',
  CAMPAIGN_CAMPAIGN_NODES_ACTIVITIES_EXPIRE_IN_LABEL: 'Expire In',
  CAMPAIGN_CAMPAIGN_NODES_ACTIVITIES_EXPIRE_IN_HINT:
    'The number of days the user has to complete this activity. Use 0 if the activity should never expire.',
  /* Rules template names */
  COMPLETE_CAMPAIGN_MEET_REWARD_POINT_THRESHOLD:
    'Complete Campaign based on meeting Reward point threshold',
  CAMPAIGN_PROGRAM_BY_AGE: "Segment by user's age",
  CAMPAIGN_PROGRAM_WITH_ONE_RULE_CONDITION: 'Program with 1 rule condition',
  CAMPAIGN_PROGRAM_WITH_NOT_CONDITION: 'Program with not condition',
  CAMPAIGN_PROGRAM_WITH_ALL_MATCH: 'Program with all match',
  CAMPAIGN_PROGRAM_WITH_ANY_MATCH: 'Program with any match',
  CAMPAIGN_PROGRAM_WITH_MULTIPLE_RULE_CONDITIONS:
    'Program with multiple rule conditions',
  CAMPAIGN_PROGRAM_WITH_ANY_MATCH_AND_JOINED_BEFORE_DAYS:
    'Program with any match and joined before days',
  CAMPAIGN_ELIGIBILITY_SEGMENT_EVEN_AND_ODD_AGE: 'Segment by Even and Odd Age',
  CAMPAIGN_ELIGIBILITY_COMPLETED_CAMPAIGN_BEFORE_DATE:
    'Check if the user completed a campaign before a certain date',
  CAMPAIGN_BRANCHING_WAITING_FOR_ALL_ACTIVE_ACTIVITIES_TO_BE_TERMINATED:
    'Wait for all active activities to be terminated before proceeding',
  CAMPAIGN_BRANCHING_USER_RISK_FACTOR_INPUT_IS_ONE_OF_VALUES:
    'User risk factor input is one of values',
  CAMPAIGN_BRANCHING_QUESTIONNAIRE_RESPONSE_IS_ONE_OF_VALUES:
    'Questionnaire response is one of values',
  CAMPAIGN_ENROLLABLE_LABEL: 'Enrollable',
  CAMPAIGN_ENROLLABLE_HINT:
    'Uncheck this box to prevent any new users from joining this campaign. This is useful for closing a campaign to new members while allowing current ones to finish.',
  CAMPAIGN_IMPACTED_MEMBERS_LABEL: 'Impacted members',
  CAMPAIGN_IMPACTED_MEMBERS_HINT:
    "<strong>This field specifies the population of users affected by republishing the campaign.</strong><ul><li>'New enrollments only'- Keeps current participants unchanged.</li><li>'Current and new enrollments' - Updates the campaign for all users.</li></ul>This does not apply to Challenges.",
  CAMPAIGN_IMPACTED_MEMBERS_NEW: 'New enrollments only',
  CAMPAIGN_IMPACTED_MEMBERS_CURRENT: 'Current and new enrollments',
  CAMPAIGN_ENROLMENT_ENROLMENT_METHOD_PLACEHOLDER:
    'Choose an enrollment method',
  CAMPAIGN_ENROLMENT_ENROLMENT_METHOD_OPT_IN: 'Opt in',
  CAMPAIGN_ENROLMENT_ENROLMENT_METHOD_AUTO_ENROLLED: 'Auto enrolled',
  CAMPAIGN_ENROLMENT_ENROLMENT_METHOD_CARE_TEAM_MEMBER: 'Assigned',
  CAMPAIGN_ENROLMENT_AUTO_UNENROLLABLE_LABEL: 'Auto Unenrollable',
  CAMPAIGN_ENROLMENT_AUTO_UNENROLLABLE_HINT:
    'Set this to true if you want users to be automatically unenrolled from this campaign when they lose eligibility. If not set, users will remain enrolled in the campaign even if they lose eligibility.',
  CAMPAIGN_NODE_PROPERTIES: 'Campaign Node Properties',
  ACTION_PROPERTIES: 'Action Properties',
  ACTION_NODE: 'Action Node',
  ACTION_TYPE: 'Action Type',
  SELECT_AN_ACTION: 'Select an Action',
  NODE_ID: 'Node ID',
  NODE_LABEL: 'Node Name',
  NODE_LABEL_HINT:
    'A friendly name for this node to help you identify it in the flow diagram (e.g., "Week 1 Activities", "Check for Pedometer").',
  CAMPAIGN_NODES_TRANSITIONS_LABEL: 'Next Nodes',
  CAMPAIGN_NODES_TRANSITIONS_HINT:
    '<strong>Required.</strong> You must specify at least one next node for the user to go to after finishing this segment.',
  CAMPAIGN_NODE: 'Node',
  CAMPAIGN_FLOW: 'Campaign Flow',
  CAMPAIGN_NODES_LABEL_ADD: 'Add a Campaign Node',
  CAMPAIGN_NODES_NEXT_NODE_REF_LABEL: 'Next Node ID',
  CAMPAIGN_NODES_DECISION_RESULT_LABEL: 'Segmentation Rule Result',
  CAMPAIGN_NODES_RESULT_TRUE_FALSE:
    'This is the result of the evaluation of the rule above. It is either true or false.',
  IF_TRUE: 'If true',
  IF_FALSE: 'If false',
  CAMPAIGN_NODES_SELECT_DECISION_RULE_RESULT: 'Select a rule result',
  CAMPAIGN_NODES_ACTIVITY_SETS: 'Activity Sets',
  CAMPAIGN_NODES_ACTIVITY_SET: 'Activity Set',
  CAMPAIGN_NODES_ADD_ACTIVITY_SET: 'Add an Activity Set',
  CAMPAIGN_NODES_SET_SIZE: 'Number of activities chosen',
  CAMPAIGN_NODES_SET_SIZE_HINT:
    'This is the number of activities that will be selected by the system from the set below, based on eligibility. If left blank, as many as possible from the list will be selected.',
  CAMPAIGN_NODES_POINTS: 'Points',
  CAMPAIGN_NODES_POINTS_HINT:
    'The number of points the user gets for completing the required number of activities in this set.',
  CAMPAIGN_NODES_ACTIVITY_SET_NAME: 'Activity Set Name',
  CAMPAIGN_NODES_ACTIVITY_SET_NAME_HINT:
    'A name for you identify this specific group of activities (e.g., "Monday\'s Tasks", "Mindfulness Exercises").',
  CAMPAIGN_NODES_DECISION_NODE: 'Decision Node',
  CAMPAIGN_NODES_SEGMENT_NODE: 'Campaign Segment Node',
  CAMPAIGN_NODES_BRANCHING_RULE: 'Branching Rule',
  CAMPAIGN_NODES_BRANCHING_RULE_HINT:
    "This field requires a valid logical rule to split the user's path. Please consult documentation to configure correctly.",
  CAMPAIGN_NODES_BRANCHING_RULE_AI_PROMPT_PLACEHOLDER:
    'Describe the branching rule in plain language...',
  CAMPAIGN_NODES: 'Campaign Nodes',
  NODE_NAME: 'Node Name',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_COLLECTION_LABEL: 'Data Collection',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_COLLECTION_HINT:
    'Optional. Use these fields if the campaign uses data from wearables (like steps or sleep) to let the user know what is being tracked.',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_LABEL: 'Data Tracked',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_HINT:
    'Select the main type of health data this campaign tracks to display an icon to the user (e.g., a shoe for "Steps").',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_STEPS: 'Steps',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_ACTIVE_DURATION: 'Active Duration',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_MINDFUL_DURATION: 'Mindful Duration',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_SLEEP_DURATION: 'Sleep Duration',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_FLOORS_CLIMBED: 'Floors Climbed',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_DISTANCE: 'Distance Traveled',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_FIELD_ENERGY_BURNED: 'Energy Burned',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_CALLOUT_CTA_TEXT_LABEL: 'Callout CTA Text',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_CALLOUT_CTA_TEXT_HINT:
    'If you need a button to link to an external page (like a privacy policy), enter the button text here (e.g., "Learn More").',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_CALLOUT_CTA_URL_LABEL: 'Callout CTA URL',
  CAMPAIGN_CONTENT_CAMPAIGN_DATA_CALLOUT_CTA_URL_HINT:
    'Enter the full URL that the button should link to.',
  CAMPAIGN_META_DATA_TYPE_PLACEHOLDER: 'Select an option',
  CAMPAIGN_META_DATA_TYPE_SUGGESTED: 'Suggested',
  CAMPAIGN_META_DATA_TYPE_REWARD: 'Reward',
  CAMPAIGN_META_DATA_TYPE_OPT_IN: 'Opt In',
  CAMPAIGN_META_DATA_TYPE_CHALLENGE: 'Challenge',
  CAMPAIGN_TOPICS_LABEL: 'Topics',
  CAMPAIGN_TOPICS_HINT:
    '<strong>Enter one topic per line.</strong> Topics help organize content. Some campaign types may have required topics. Check your documentation if you are unsure.',
  CAMPAIGN_METADATA_TOPIC_ITEM_LABEL: 'Topic',
  CAMPAIGN_AWARD_ATTEMPTS_LABEL: 'Award Attempts Allowed',
  CAMPAIGN_AWARD_ATTEMPTS_HINT:
    'Determines how many times points can be awarded for activity completion. Must be a whole number. <strong>Leave blank to allow infinite awards for repeatable activities.</strong> Use 0 to prevent any points from being awarded. Not supported for Suggested campaigns',
  CAMPAIGN_CHALLENGE_CONFIG_LABEL: 'Challenge Configuration',
  CAMPAIGN_CHALLENGE_NAME_LABEL: 'Name',
  CAMPAIGN_CHALLENGE_NAME_HINT:
    'Not visible to users. Used for internal findability purposes.',
  CAMPAIGN_CHALLENGE_DESCRIPTION_LABEL: 'Description',
  CAMPAIGN_CHALLENGE_DESCRIPTION_HINT:
    'Not visible to users. Used for internal summary purposes.',
  CAMPAIGN_CHALLENGE_PRIZE_LABEL: 'Prize',
  CAMPAIGN_CHALLENGE_PRIZE_HINT:
    'Describe the prize participants can win. You can use rich text formatting.',
  CAMPAIGN_CHALLENGE_RULES_LABEL: 'Challenge Rules',
  CAMPAIGN_CHALLENGE_RULES_HINT:
    'Explain the official rules for the challenge. You can use rich text formatting.',
  CAMPAIGN_CHALLENGE_TYPE_LABEL: 'Challenge Type',
  CAMPAIGN_CHALLENGE_TYPE_HINT:
    "'Solo' is for individual challenges. 'Group' enables team features and leaderboards.",
  CAMPAIGN_CHALLENGE_TYPE_SOLO: 'Solo',
  CAMPAIGN_CHALLENGE_TYPE_GROUP: 'Group',
  CAMPAIGN_CHALLENGE_GROUP_CHALLENGE_SETTINGS_LABEL: 'Group Challenge Settings',
  CAMPAIGN_CHALLENGE_TEAM_CONFIG_LABEL: 'Team Configuration',
  CAMPAIGN_CHALLENGE_TEAM_CONFIG_HINT:
    "'Team': allows participants to form teams. 'Individual': participants compete solo on the leaderboard.",
  CAMPAIGN_CHALLENGE_TEAM_CONFIG_TEAM: 'Team',
  CAMPAIGN_CHALLENGE_TEAM_CONFIG_INDIVIDUAL: 'Individual',
  CAMPAIGN_CHALLENGE_TEAM_SIZE_LABEL: 'Maximum Team Size',
  CAMPAIGN_CHALLENGE_TEAM_SIZE_HINT:
    "<strong>Required</strong> if Team Configuration is 'Team'. Enter the maximum number of people allowed on a team. Must be a whole number between 2 and 500.",
  CAMPAIGN_CHALLENGE_RANKING_CRITERION_LABEL: 'Ranking Criterion',
  CAMPAIGN_CHALLENGE_RANKING_CRITERION_HINT:
    'Choose the metric that will be used to rank participants on the leaderboard (e.g., rank by "Steps" or by "Number of Activities").',
  CAMPAIGN_CHALLENGE_RANKING_CRITERION_ACTIVE_DURATION: 'Active Duration',
  CAMPAIGN_CHALLENGE_RANKING_CRITERION_NUM_OF_ACTIVITIES:
    'Number of Activities',
  CAMPAIGN_CHALLENGE_RANKING_CRITERION_STEPS: 'Steps',
  CAMPAIGN_CHALLENGE_RANKING_CRITERION_MINDFUL_DURATION: 'Mindful Duration',
  CAMPAIGN_CHALLENGE_SEGMENTATION_RULE_LABEL: 'User Segmentation Rule',
  CAMPAIGN_CHALLENGE_SEGMENTATION_RULE_HINT:
    'Use this advanced feature to create separate leaderboards for different groups of users (e.g., users in the same company). Please consult documentation before using.',
  CAMPAIGN_CHALLENGE_RULE_SAME_COMPANY: 'Users from the same company.',
  CAMPAIGN_CHALLENGE_RULE_SPECIFIC_COMPANY: 'Users from a specific company.',
  CAMPAIGN_CHALLENGE_RULE_LIST_OF_COMPANIES: 'Users from a list of companies.',
  CAMPAIGN_RECOMMENDATION_RULES_LABEL: 'Recommendation Rules',
  CAMPAIGN_RECOMMENDATION_RULES_HINT:
    'This page configures how this campaign shows up in Suggested For You / Your Daily Picks. This campaign will be recommended to users who meet ANY of these rules. If no rules are configured, then this campaign will not be recommended to anyone.',
  CAMPAIGN_RECOMMENDATION_RULE_LABEL: 'Recommendation Rule',
  CAMPAIGN_RECOMMENDATION_RULE_HINT:
    'A user must match at least one of these rules to see this campaign in their recommendations. If no rules are added, this campaign will never be recommended. You can use ALL_USERS to match all users in both the inclusion and exclusion criteria.',
  CAMPAIGN_RECOMMENDATION_RULE_INCLUSION_CRITERIA_LABEL: 'Inclusion Criteria',
  CAMPAIGN_RECOMMENDATION_RULE_INCLUSION_CRITERIA_HINT:
    'This campaign will be recommended if ALL of the inclusion criteria are met.',
  CAMPAIGN_RECOMMENDATION_RULE_CRITERION_LABEL: 'Criterion',
  CAMPAIGN_RECOMMENDATION_RULE_CRITERION_VALUE_LABEL: 'Value',
  CAMPAIGN_RECOMMENDATION_RULE_EXCLUSION_CRITERIA_LABEL: 'Exclusion Criteria',
  CAMPAIGN_RECOMMENDATION_RULE_EXCLUSION_CRITERIA_HINT:
    'This campaign will NOT be recommended if ANY of the exclusion criteria are met.',
  CAMPAIGN_TYPE: 'Campaign Type',
  CAMPAIGN_ID: 'Campaign Id',
  REWARD_PROGRAM_IDS: 'Reward Program IDs',
  REWARD_PROGRAM_ID: 'Reward Program ID',
  CAMPAIGN_CHILD_CAMPAIGNS_ITEM: 'Child Campaign',
  CAMPAIGN_FLOW_TYPE_ID: 'Campaign Flow Type ID',
  NODE: 'Node',
  FLOW_TYPE_VERSION: 'Flow Type Version',
  CAMPAIGN_WITH_COHORTS: 'User belongs to a cohort',
};
